<template>
  <div class="pub-form">
    <div
      class="layui-form-item"
      v-for="(item, index) in config.render"
      :key="index">
      <label class="layui-form-label" v-if="!item.hide">
        <span v-show="item.required" class="x-red">*</span>
        {{ item.label + '：' }}
      </label>

      <template v-for="(e, ind) in item.children" >
        <div :key="e.type + ind" :class="{ 'layui-input-inline': direction === 'inline'}"  v-if="!item.hide">
          <!-- <input v-if="e.type === 'input'" type="text" v-model="config.form[e.name]" :name="e.name" autocomplete="off" class="layui-input" :disabled="config.disabled ? true : e.enabled" /> -->
          <input v-if="e.type === 'input'" type="text" v-model="config.form[e.name]" :name="e.name" autocomplete="off" :class="['layui-input', config.disabled || e.enabled ? 'layui-disabled' : '']" :disabled="config.disabled ? true : e.enabled"/>

          <layui-date
            :ref="e.ref"
            v-if="e.type === 'date'"
            placeholder="请输入时间"
            v-model="config.form[e.name]"
            :name="e.name"
            :enabled="config.disabled ? false : e.enabled"
          />
          <layui-daterange
            :ref="e.ref"
            v-if="e.type === 'daterange'"
            placeholder="请输入时间"
            v-model="config.form[e.name]"
            :name="e.name"
            :enabled="config.disabled ? false : e.enabled"
          />
          <layui-datetime
            :ref="e.ref"
            v-if="e.type === 'datetime'"
            placeholder="请输入时间"
            v-model="config.form[e.name]"
            :name="e.name"
            :enabled="config.disabled ? false : e.enabled"
          />
          <layui-datetimerange
            :ref="e.ref"
            v-if="e.type === 'datetimerange'"
            placeholder="请输入时间"
            v-model="config.form[e.name]"
            :name="e.name"
            :enabled="config.disabled ? false : e.enabled"
            />

          <layui-select
            v-if="e.type === 'select'"
            :ref="e.ref"
            v-model="config.form[e.name]"
            :table-name="e.tableName"
            :text-field="e.textField"
            :value-field="e.valueField"
            :queryCondition="e.queryCondition"
            :enableSearch="e.enableSearch"
            :enabled="config.disabled ? false : e.enabled"
            :sort="e.sort"
            :showNullOption="true"
            :name="e.name"
            :renderText="e.renderText"
            @selectChange="_selectChange($event, e.name)"
          />

          <layui-select
            v-if="e.type === 'select-solt'"
            :ref="e.ref"
            v-model="config.form[e.name]"
            :name="e.name"
            :init-value = e.initValue
            :enabled="config.disabled ? false : e.enabled"
            :showNullOption="true"
          >
            <option v-for="j in e.options" :key="j.value" :value="j.value">{{ j.text }}</option>
          </layui-select>

          <layui-zqselect
            :ref="e.ref"
            v-if="e.type === 'area'"
            v-model="config.form[e.name]"
            :maxLoadLevel="3"
            :maxWidth="600"
            :name="e.name"
            :enabled="config.disabled ? false : e.enabled"
            placeholder = "请选择政区"
          >
          </layui-zqselect>

          <layui-radio
            :ref="e.ref"
            v-if="e.type === 'radio'"
            v-model="config.form[e.name]"
            :init-value = e.initValue
            :enabled=" config.disabled ? false : e.enabled"
          >
              <input
                type="radio"
                v-for="j in e.options"
                :key="j.value"
                :value="j.value"
                :title="j.title" />
          </layui-radio>

          <layui-check
            :ref="e.ref"
            v-if="e.type === 'check'"
            v-model="config.form[e.name]"
            :enabled=" config.disabled ? false : e.enabled"
            :initData="e.options"
          >

          </layui-check>

            <region-select
            v-if="e.type === 'cusCmp'"
              :ref="e.ref"
              v-model="config.form[e.name]"
              @change="change"
            ></region-select>

          <!-- <textarea v-if="e.type === 'textarea'"  v-model="config.form[e.name]"  style="width:380px" class="layui-textarea" :disabled="config.disabled ? true : e.enabled" /> -->
          <textarea v-if="e.type === 'textarea'"  v-model="config.form[e.name]"  :class="['layui-textarea',  config.disabled || e.enabled  ? 'layui-disabled' : '']" :disabled="config.disabled ? true : e.enabled" />

          <div v-if="e.type === 'text'" class="layui-form-mid layui-word-aux">{{ e.text }}</div>

          <layui-fileupload
            :ref="e.ref"
            v-if="e.type === 'uploadFile'"
            v-model="config.form[e.name]"
            :enabled="config.disabled ? false : e.enabled"
            :business-table="e.table"
            :business-field="e.field">
              <template  slot-scope="{scope}">
                    <button type="button" class="layui-btn layui-btn-primary" @click="scope.upload()" style="background-color:white;margin-top:7px;">
                        <i class="layui-icon"></i>上传文件
                    </button>
              </template>
          </layui-fileupload>

          <layui-imgupload
            :ref="e.ref"
            v-if="e.type === 'uploadImg'"
            v-model="config.form[e.name]"
            :enabled="config.disabled ? false : e.enabled"
            :business-table="e.table"
            :business-field="e.field">
              <template  slot-scope="{scope}">
                    <button type="button" class="layui-btn layui-btn-primary" @click="scope.upload()" style="background-color:white;;margin-top:7px;">
                        <i class="layui-icon"></i>上传图片
                    </button>
              </template>
          </layui-imgupload>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import LayuiDatetimerange from './LayuiDatetimerange.vue'
export default {
  components: { LayuiDatetimerange },
  name: 'pub-form',
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    // inline || vertical
    direction: { type: String, default: 'inline' }
  },
  data () {
    return {
    }
  },
  methods: {
    /**
     * 下拉框changge事件
     */
    _selectChange (data, field) {
      this.$emit('selectChange', data, this.$refs, field)
    },
    change(val,fn){
      this.$emit('selectArea',val,fn)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/pub-form.vue